/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Assistant/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Assistant({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Events/Content/Content/Content/Content/Events/Content/Compact/Past/Content/Content/NotesHeader/Notes/Content/AppointmentCell/AssistantAndProvider/Assistant"
  
}) {
let eventAppointmentBookingAssistantEmploymentContractPersonValueData = fromData.useDataFormat({ viewPath,
context: 'event',
path: 'appointment.booking.assistant.employment_contract.person',
format: fromFormat.personName,
})
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="event.appointment.booking.assistant.employment_contract.person"
 format="/Data/format.js personName"
 text={eventAppointmentBookingAssistantEmploymentContractPersonValueData}
 color={dtColorsNeutral700}
/>
{children}
</React.Fragment>)
}